<script>
import * as Units from '@/lib/units';
import Btn from "@/components/atoms/Btn";
import BtnRow from "@/components/atoms/BtnRow";
import Banner from "@/components/atoms/Banner";
import PartRow from "@/components/atoms/PartRow";
import PartTable from "@/components/atoms/PartTable";
// import vendors from "@/data/parts/vendors.js";
import In from "@/components/atoms/In.vue";

export default {
  components: {Banner, Btn, BtnRow, PartRow, In, PartTable},
  props: [], 
  created(){
    console.log(this.order)
  },
  computed: {
    order(){
      return this.$store.get('payment/pendingOrder') ? this.$store.get('payment/pendingOrder') : {ledger: []};
    },
    selectedTotal(){
      let materialTotal = 0;
      let machiningTotal = 0;
      this.order.ledger.forEach(ledgerPart => {
        let materialPrice = ledgerPart.materialPrice ? ledgerPart.materialPrice : 0;
        let machiningPrice = ledgerPart.machiningPrice ? ledgerPart.machiningPrice : 0;
        materialTotal += materialPrice * (ledgerPart.customQuantity ? ledgerPart.customQuantity : ledgerPart.quantity);
        machiningTotal += machiningPrice * (ledgerPart.customQuantity ? ledgerPart.customQuantity : ledgerPart.quantity);
      })
      return Units.roundDollars(materialTotal + machiningTotal);
    },
    itemCount(){
      let count = 0;
      this.order.ledger.forEach(ledgerPart => {
        count += Number((ledgerPart.customQuantity ? ledgerPart.customQuantity : ledgerPart.quantity))
      })
      return count;
    },
    hasPanel(){
      if(this.order.ledger){
        return this.order.ledger.some(ledgerPart => ledgerPart.customLength && ledgerPart.customWidth && !ledgerPart.customHeight)
      }else{
        return false;
      }
    }
  },
  methods: {
    checkout(){
      const ledger = this.order.ledger.map(part => ({
        ...part,
        quantity: Number(part.customQuantity ? part.customQuantity : part.quantity)
      }))
      this.$store.dispatch("payment/getOrderFromLedger", ledger).then(order => {
        this.$store.dispatch('payment/pendingOrder', {
          ...this.order,
          ...order
        });
        this.$router.push({name: 'Order'})
      });
    },
    removePart(index){
      const newLedger = this.order.ledger;
      newLedger.splice(index, 1);
      if(newLedger.length > 0){
        this.$store.dispatch('payment/pendingOrder', {
          ...this.order,
          ledger: newLedger
        });
      }else{
        this.$store.dispatch('payment/pendingOrder', null);
      }
      this.$toast("Item Removed", {
        type: "success",
      });
    },
    clearCart(){
      this.$store.commit('confirm', {
        title: "Clear Cart?",
        description: "This will remove all of the items from your cart.",
        stop_label: "Cancel",
        start_label: "Clear",
        start: ()=>{
          this.$store.dispatch('payment/pendingOrder', null);
          this.$toast("Removed All Items", {
            type: "success",
          });
        },
        stop: ()=>{}
      })
    }
  }
  
}
</script>

<template>
  <Banner>
    <div class="cart">
      <div class="cart-module">
        <div class="cart-title">
          <span class="fa fa-shopping-cart"></span>
          My Cart
        </div>
        <div class="warnings">
          <div class="panel-warning info" v-if="hasPanel">
            <span class="fa fa-exclamation-triangle"></span>
            WARNING: Quadrobee does not provide machining services for panels. Please contact Support@quadrobee.com to place a custom order.
          </div>
          <div class="panel-warning info" v-if="false">
            <span class="fa fa-exclamation-triangle"></span>
            WARNING: Quadrobee is still in Beta. Please double-check your parts, dimensions, and machining services before placing an order.
          </div>
        </div>
        <div class="parts-row">
          <PartTable>
            <div class="headers row">
              <div class="item-col">Items</div>
              <div class="quantity-col">Qty</div>
              <div class="price-col">Price</div>
              <div class="total-price-col">Total</div>
              <div class="remove fa fa-times" @click="clearCart"></div>
            </div>
            <div v-if="order">
              <PartRow v-for="(ledgerPart, index) in order.ledger" :key="index" :ledgerPart="ledgerPart" :index="index" ref="part" :number="index" :show-select="false" :show-remove="true" @remove="() => removePart(index)"></PartRow>
            </div>
          </PartTable>
        </div>
      </div>
      <div class="checkout-area" v-if="order" :class="{mobile: $store.get('usingMobile')}">
        <div class="checkout">
          <div class="left">
            Items: {{itemCount}}
          </div>
          <div class="right">
            <div class="total">
              <span class="text">est. Total </span><span class="price">${{selectedTotal}}</span>
            </div>
            <div class="purchase">
              <btn type="fill" @click="checkout">Purchase</btn>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Banner>
</template>

<style lang="scss">
@import "~@/styles/constants";
.cart{
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: $black_2;
  flex: 1;
  .cart-module{
    flex-basis: 80rem;
    padding: 1rem;
    margin-bottom: 6rem;
    .cart-title{
      font-size: 2rem;
      margin-top: 2rem;
      .fa{
        margin-right: 0.5rem;
        // color: $p;
      }
    }
    .warnings{
      margin-top: 1rem;
      .panel-warning{
        margin-bottom: 0.5rem;
        border-radius: 4px;
        padding: 1rem 2rem;
        font-size: 1.25rem;
        .fa{
          font-size: 1.125rem;
        }
        &.warning{
          background-color: $black_4;
        }
        &.info{
          background-color: $black_3;
        }
      }
    }
    .back-row{
      margin-bottom: 2rem;
      .button{
        font-size: 1.5rem;
      }
      i{
        padding-right: 0.5rem;
      }
    }
    .main-row{
      display: flex;
      align-items: flex-start;
      margin-bottom: 3rem;
      .image-col{
        width: 50%;
        // border: 2px solid $black_3;
        border-radius: 6px;
        img{
          width: 100%;
          filter: brightness(2.5);
        }
      }
    }
  }
  .checkout-area{
    position: fixed;
    bottom: 0rem;
    left: 0rem;
    width: 100%;
    border-top: 2px solid $black_2;
    background-color: $black_1;
    display: flex;
    align-items: center;
    justify-content: center;
    &.mobile{
      position: relative;
      .checkout{
        flex-wrap: wrap;
        .left{
          margin-left: 0rem;
        }
        .right{
          flex-wrap: wrap;
          .total{
            padding-left: 0rem;
            padding-bottom: 1rem;
          }
          .purchase {
            flex: 1;
            .button{
              flex: 1;
            }
          }
        }
      }
    }
    .checkout{
      z-index: 100;
      display: flex;
      align-items: center;
      flex-basis: 80rem;
      justify-content: space-between;
      padding: 1.5rem 2rem;
      .left, .right{
        display: flex;
        align-items: center;
      }
      .left{
        // margin-left: 1rem;
        font-size: 1.5rem;
      }
      .total{
        display: flex;
        align-items: center;
        justify-content: flex-end;
        font-size: 1.5rem;
        padding: 0rem 2rem;
        .text{
          margin-right: 1rem;
          color: $w_1;
        }
        .price{
          
        }
      }
      .purchase{
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .button{
          width: 20rem;
        }
      }
      .checkout-module{
        flex-basis: 80rem;
        padding: 2rem;
        .input-row{
          display: flex;
          align-items: center;
          .input{
            padding: 0.5rem;
            flex: 1;
          }
        }
        .error-row{
          color: $error;
          padding: 0.5rem;
        }
        .button-row{
          padding: 0.5rem;
        }
      }
    }
  }
  .overlay{
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.5);
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    .module{
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 5rem 6rem;
      border-radius: 0.5rem;
      &.saving{
        background-color: #444;
      }
      &.saved{
        background-color: #48c586;
      }
      .press{
        width: 15rem;
        margin-bottom: 4rem;
      }
      .text{
        font-size: 2rem;
        margin-bottom: 1.5rem;
      }
      .sub-text{
        font-size: 1.25rem;
        max-width: 30rem;
        text-align: center;
      }
      .fas{
        font-size: 3rem;
        margin-bottom: 1.5rem;
        // color: #64f7ad;
      }
      .saved{
        font-size: 2rem;
        margin-bottom: 0.5rem;
        // color: #64f7ad;
      }
    }
  }
  .fade-loading-enter-active{
    transition: all 0.4s;
  }
  .fade-loading-leave-active{
    transition: all 0.2s;
  }
  .fade-loading-enter{
    opacity: 0;
  }
  .fade-loading-leave-to{
    opacity: 0;
  }
}
</style>